import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TANUH_MODEL_SECURITY_FLOW_ASSET_URL } from '../../shared/constants/tanuh-model-security.constants';

@Component({
  selector: 'app-model-security-flow',
  standalone: true,
  imports: [CommonModule],
  template: `
    <iframe
      class="model-security-flow__frame"
      [src]="flowUrl"
      title="How your model stays secure in TANUH"
    ></iframe>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100vh;
        background: #f8fafc;
      }

      .model-security-flow__frame {
        width: 100%;
        height: 100%;
        border: 0;
      }
    `,
  ],
})
export class ModelSecurityFlowComponent {
  readonly flowUrl = TANUH_MODEL_SECURITY_FLOW_ASSET_URL;
}
